import { useParams, Navigate } from 'react-router-dom';
import Header from '../../components/layout/Header/Header';
import Footer from '../../components/layout/Footer/Footer';
import WhatsAppButton from '../../components/ui/WhatsAppButton/WhatsAppButton';
import Seo from '../../components/utils/Seo';
import { getProjectBySlug, getOtherProjects } from '../../data/projects';

import ProjectHero from '../../sections/ProjectDetail/ProjectHero/ProjectHero';
import ProjectQuickFacts from '../../sections/ProjectDetail/ProjectQuickFacts/ProjectQuickFacts';
import ProjectOverview from '../../sections/ProjectDetail/ProjectOverview/ProjectOverview';
import ProjectUnitMix from '../../sections/ProjectDetail/ProjectUnitMix/ProjectUnitMix';
import ProjectAmenities from '../../sections/ProjectDetail/ProjectAmenities/ProjectAmenities';
import ProjectParking from '../../sections/ProjectDetail/ProjectParking/ProjectParking';
import ProjectGallery from '../../sections/ProjectDetail/ProjectGallery/ProjectGallery';
import ProjectFloorPlans from '../../sections/ProjectDetail/ProjectFloorPlans/ProjectFloorPlans';
import ProjectBrochure from '../../sections/ProjectDetail/ProjectBrochure/ProjectBrochure';
import ProjectLocation from '../../sections/ProjectDetail/ProjectLocation/ProjectLocation';
import ProjectPartners from '../../sections/ProjectDetail/ProjectPartners/ProjectPartners';
import ProjectEnquiryCTA from '../../sections/ProjectDetail/ProjectEnquiryCTA/ProjectEnquiryCTA';
import RelatedProjects from '../../sections/ProjectDetail/RelatedProjects/RelatedProjects';

import './ProjectDetail.css';

export default function ProjectDetail() {
  const { slug } = useParams();
  const project = getProjectBySlug(slug);

  if (!project) return <Navigate to="/projects" replace />;

  const related = getOtherProjects(project.slug, 3);

  const scrollToGallery = () => {
    document.getElementById('gallery')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className="pd-page">
      <Seo
        title={project.seo?.title || project.name}
        description={project.seo?.description || project.shortDescription}
        image={project.seo?.ogImage}
        path={`/projects/${project.slug}`}
      />
      <Header />

      <main>
        <ProjectHero project={project} onViewGallery={scrollToGallery} />
        <ProjectQuickFacts project={project} />
        <ProjectOverview project={project} />
        <ProjectUnitMix project={project} />
        <ProjectAmenities project={project} />
        <ProjectParking project={project} />
        <ProjectGallery project={project} />
        <ProjectFloorPlans project={project} />
        <ProjectBrochure project={project} />
        <ProjectLocation project={project} />
        <ProjectPartners project={project} />
        <ProjectEnquiryCTA project={project} />
        <RelatedProjects projects={related} />
      </main>

      <Footer />
      <WhatsAppButton />
    </div>
  );
}
